import * as React from "react";
import { useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import logo from "../assets/OSBYOSLogo.jpg";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Collapse from "@mui/material/Collapse";

const theme = createTheme({
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: "#010203",
          width: "100%",
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          display: "flex",
          justifyContent: "center",
          width: "100%",
        },
      },
    },
    MuiCollapse: {
      styleOverrides: {
        root: {
          background: "#010203",
          color: "#FEFEFE",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "Melbourne",
          fontSize: "1rem",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: "Melbourne",
        },
      },
    },
  },
});

const drawerWidth = "50%";
const navItems = [
  "COLLECTION",
  "CELEBRITIES",
  "PRESS",
  "TRUNK SHOW",
  "ABOUT US",
  "SHOP",
  "CONTACT",
];

export default function DrawerAppBar(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const navigate = useNavigate();
  const [collection, setCollection] = React.useState(false);
  const [open, setOpen] = React.useState(true);

  const handleClick = () => {
    setOpen(!open);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const navHandler = (value) => {
    if (value === "CONTACT") {
    return navigate("/Contact");
  } else if (value === "CELEBRITIES") {
    return navigate("/Celebrities");
  } else if (value === "SHOP") {
    return navigate("/Shop");
  } else if (value === "TRUNK SHOW") {
    return navigate("/TrunkShow");
  } else if (value === "PRESS") {
    return navigate("/Press");
  }else if (value === "ABOUT US") {
    return navigate("/AboutUs");
  }
  };
  const mouseEnter = (value) => {
    if (value == "COLLECTION") {
      setCollection(true);
    }
  };

  const mouseLeave = (value) => {
    if (value == "COLLECTION") {
      setCollection(false);
    }
  };

  const navCollection = () => {
    setMobileOpen(!mobileOpen);
    navigate("/Collection", { state: { type: "os22", row: 3 } });
  };
  const navCollectionEvent = () => {
    setMobileOpen(!mobileOpen);
    navigate("/Collection", { state: { type: "os21", row: 3 } })
  };

  const os20 = () => {
    setMobileOpen(!mobileOpen);
    navigate("/Collection", { state: { type: "os20", row: 3 } })
  };

   const os24 = () => {
    setMobileOpen(!mobileOpen);
    navigate("/Collection", { state: { type: "os24", row: 3 } })
  };
   const os24evento = () => {
    setMobileOpen(!mobileOpen);
    navigate("/Collection", { state: { type: "os24evento", row: 3 } })
  };

    const osss25 = () => {
    setMobileOpen(!mobileOpen);
    navigate("/Collection", { state: { type: "osss25", row: 3 } })
  };

  const osss25evento = () => {
    setMobileOpen(!mobileOpen);
    navigate("/Collection", { state: { type: "osss25evento", row: 3 } })
  };


  const logonav = () => {
    navigate("/")
  };

  const drawer = (
    <Box
      sx={{
        textAlign: "center",
        backgroundColor: "#010203",
        color: "#fff",
        fontSize: "2rem",
        fontFamily: "Melbourne",
      }}
       onMouseLeave={handleDrawerToggle}
    >
      <ThemeProvider theme={theme}>
        <Typography variant="h4" sx={{ my: 2 }}>
          OSBYOS
        </Typography>
        <Divider />
        <List>
          {navItems.map((item,index) =>
            item == "COLLECTION" ? (
              <>
                <ListItem key={`${item}-${index}`}>
                  <ListItemButton
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                    onClick={osss25}
                  >
                    <ListItemText primary="OS25" />
                  </ListItemButton>
                </ListItem>
                <ListItem key={`${item}-${index}`}>
                  <ListItemButton
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                    onClick={os24}
                  >
                    <ListItemText primary="OS24" />
                  </ListItemButton>
                </ListItem>
                <ListItem key={`${item}-${index}`}>
                  <ListItemButton
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                    onClick={navCollection}
                  >
                    <ListItemText primary="OS 22" />
                  </ListItemButton>
                </ListItem>
                <ListItem key={`${item}-${index}`}>
                  <ListItemButton
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                    onClick={navCollectionEvent}
                  >
                    <ListItemText primary="OS21" />
                  </ListItemButton>
                </ListItem>
                <ListItem key={`${item}-${index}`}>
                  <ListItemButton
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                    onClick={os20}
                  >
                    <ListItemText primary="OS20" />
                  </ListItemButton>
                </ListItem>
              </>
            ) : (
              <ListItem key={`${item}-${index}`}>
                <ListItemButton
                  onClick={() => {
                    navHandler(item);
                  }}
                  sx={{ textAlign: "center" }}
                >
                  <ListItemText primary={item} />
                </ListItemButton>
              </ListItem>
            )
          )}
        </List>
      </ThemeProvider>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <React.Fragment>
      <Box sx={{ display: "flex", paddingLeft: "0px", paddingRight: "0px" }}>
        <CssBaseline />
        <ThemeProvider theme={theme}>
          <AppBar component="nav" position="sticky">
            <div className="FirstAppBar">
  <div className="LogoContainer" onClick={logonav}>
    <img
      src={logo}
      alt="OSBYOS LOGO"
      className="LogoImage"
    />
  </div>

  <div className="ContactContainer">
    <Typography variant="body1" sx={{ fontSize: "1.1rem" }}>
      <a
        href="https://wa.me/919004007226"
        style={{ color: "#111010ff", textDecoration: "none" }}
      >
        +919004007226
      </a>
    </Typography>
  </div>
</div>
            <Toolbar sx={{ paddingLeft: "0px", paddingRight: "0px" }}>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{
                  position: "absolute",
                  left: "10%",
                  top: "20%",
                  mr: 2,
                  display: {
                    xs: "block",
                    sm: "block",
                    md: "none",
                    lg: "none",
                  },
                }}
              >
                <MenuIcon />
              </IconButton>
              <Box
                sx={{
                  display: {
                    xs: "none",
                    sm: "none",
                    md: "block",
                    lg: "block",
                  },
                }}
              >
                {navItems.map((item) => (
                  <Button
                    onClick={() => {
                      navHandler(item);
                    }}
                    onMouseEnter={() => {
                      mouseEnter(item);
                    }}
                    onMouseLeave={() => {
                      mouseLeave(item);
                    }}
                    key={item}
                    sx={{ color: "#fff", marginLeft: "3rem" }}
                  >
                    {item}
                  </Button>
                ))}
              </Box>
            </Toolbar>
          </AppBar>
        </ThemeProvider>

        <Box component="nav">
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: "block", sm: "block", md: "none", lg: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
                backgroundColor: "#010203",
              },
            }}>
            {drawer}
      </Drawer>
        </Box>
        <Toolbar />
      </Box>
     <ThemeProvider theme={theme}>
  <Collapse
    onMouseOver={() => setCollection(true)}
    onMouseLeave={() => setCollection(false)}
    in={collection}
    timeout={300}
    sx={{
      background: "#010203",
      borderRadius: "0 0 12px 12px",
      boxShadow: "0px 6px 20px rgba(0,0,0,0.3)",
      overflow: "hidden",
    }}
  >
    <div className="SpringSummer" style={{ padding: "12px 16px" }}>
      <List sx={{ color: "#fff" }}>
        <ListItem disablePadding>
          <ListItemButton
            onClick={osss25}
            sx={{
              "&:hover": { backgroundColor: "rgba(255,255,255,0.1)", borderRadius: 2 },
            }}
          >
            <ListItemText primary="OS25" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            onClick={os24}
            sx={{
              "&:hover": { backgroundColor: "rgba(255,255,255,0.1)", borderRadius: 2 },
            }}
          >
            <ListItemText primary="OS24" />
          </ListItemButton>
        </ListItem>
      </List>
    </div>

    <div className="Archive" style={{ padding: "12px 16px", borderTop: "1px solid rgba(255,255,255,0.1)" }}>
      <List sx={{ color: "#bbb" }}>
        <ListItem disablePadding>
          <h4 style={{ color: "#fff", margin: "8px 0" }}>Archive</h4>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            onClick={navCollection}
            sx={{
              "&:hover": { backgroundColor: "rgba(255,255,255,0.1)", borderRadius: 2 },
            }}
          >
            <ListItemText primary="OS22" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            onClick={navCollectionEvent}
            sx={{
              "&:hover": { backgroundColor: "rgba(255,255,255,0.1)", borderRadius: 2 },
            }}
          >
            <ListItemText primary="OS21" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            onClick={os20}
            sx={{
              "&:hover": { backgroundColor: "rgba(255,255,255,0.1)", borderRadius: 2 },
            }}
          >
            <ListItemText primary="OS20" />
          </ListItemButton>
        </ListItem>
      </List>
    </div>
  </Collapse>
</ThemeProvider>

    </React.Fragment>
  );
}
